"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTags = exports.checkTagUsed = exports.PLAYER_INTERFACE_TAGS_ORDER = void 0;
var vue_1 = require("vue");
var TagCount_1 = require("../TagCount");
var Tags_1 = require("../../cards/Tags");
var CardName_1 = require("../../CardName");
var SpecialTags_1 = require("../../cards/SpecialTags");
var OverviewSettings_1 = require("./OverviewSettings");
var PlayerTagDiscount_1 = require("./PlayerTagDiscount");
var JovianMultiplier_1 = require("./JovianMultiplier");
var AnimalMicrobeProtection_1 = require("./AnimalMicrobeProtection");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var TurmoilPolicy_1 = require("../../turmoil/TurmoilPolicy");
var ColonyName_1 = require("../../colonies/ColonyName");
var JOVIAN_HALF_MULTIPLIERS = [
    CardName_1.CardName.JOVIAN_OUTPOST,
];
var JOVIAN_FULL_MULTIPLIERS = [
    CardName_1.CardName.IO_MINING_INDUSTRIES,
    CardName_1.CardName.GANYMEDE_COLONY,
    CardName_1.CardName.WATER_IMPORT_FROM_EUROPA,
];
var ANIMAL_MICROBE_PROTECTION = [
    CardName_1.CardName.PROTECTED_HABITATS,
    CardName_1.CardName.PHOBOS_SPACE_HAVEN_LEAGUE,
];
var hasDiscount = function (tag, card) {
    if (tag === SpecialTags_1.SpecialTags.COLONY_COUNT || tag === SpecialTags_1.SpecialTags.CITY_COUNT)
        return false;
    if (card.discount === undefined) {
        return false;
    }
    if (tag === 'all') {
        return card.discount.tag === undefined;
    }
    return card.discount.tag === tag;
};
var getDiscountAmount = function (tag, card) {
    var _a;
    if (hasDiscount(tag, card)) {
        return ((_a = card === null || card === void 0 ? void 0 : card.discount) === null || _a === void 0 ? void 0 : _a.amount) || 0;
    }
    return 0;
};
exports.PLAYER_INTERFACE_TAGS_ORDER = [
    Tags_1.Tags.BUILDING,
    Tags_1.Tags.SPACE,
    Tags_1.Tags.SCIENCE,
    Tags_1.Tags.ENERGY,
    Tags_1.Tags.EARTH,
    Tags_1.Tags.JOVIAN,
    Tags_1.Tags.VENUS,
    Tags_1.Tags.PLANT,
    Tags_1.Tags.MICROBE,
    Tags_1.Tags.ANIMAL,
    Tags_1.Tags.CITY,
    Tags_1.Tags.MOON,
    'separator',
    Tags_1.Tags.EVENT,
    SpecialTags_1.SpecialTags.NONE,
    Tags_1.Tags.WILDCARD,
    SpecialTags_1.SpecialTags.INFLUENCE,
    SpecialTags_1.SpecialTags.CITY_COUNT,
    SpecialTags_1.SpecialTags.COLONY_COUNT,
];
var checkTagUsed = function (tag, player) {
    if (!player.game.gameOptions.coloniesExtension && tag === SpecialTags_1.SpecialTags.COLONY_COUNT) {
        return false;
    }
    if (player.game.turmoil === undefined && tag === SpecialTags_1.SpecialTags.INFLUENCE) {
        return false;
    }
    if (!player.game.gameOptions.venusNextExtension && tag === Tags_1.Tags.VENUS) {
        return false;
    }
    if (!player.game.gameOptions.moonExpansion && tag === Tags_1.Tags.MOON) {
        return false;
    }
    return true;
};
exports.checkTagUsed = checkTagUsed;
exports.PlayerTags = vue_1.default.component('player-tags', {
    props: {
        player: {
            type: Object,
        },
        isActivePlayer: {
            type: Boolean,
        },
        hideZeroTags: {
            type: Boolean,
        },
    },
    components: {
        'tag-count': TagCount_1.TagCount,
        PlayerTagDiscount: PlayerTagDiscount_1.PlayerTagDiscount,
        JovianMultiplier: JovianMultiplier_1.JovianMultiplier,
        AnimalMicrobeProtection: AnimalMicrobeProtection_1.AnimalMicrobeProtection,
    },
    methods: {
        showColonyCount: function () {
            return this.player.game.gameOptions.coloniesExtension;
        },
        showInfluence: function () {
            return this.player.game.turmoil !== undefined;
        },
        showVenus: function () {
            return this.player.game.gameOptions.venusNextExtension;
        },
        showMoon: function () {
            return this.player.game.gameOptions.moonExpansion;
        },
        showEscapeVelocity: function () {
            return this.player.game.gameOptions.escapeVelocityMode;
        },
        getTagsPlaceholders: function () {
            var _this = this;
            var tags = exports.PLAYER_INTERFACE_TAGS_ORDER;
            return tags.filter(function (tag) {
                return exports.checkTagUsed(tag, _this.player);
            });
        },
        getCardCount: function () {
            if (this.player.cardsInHandNbr) {
                return this.player.cardsInHandNbr;
            }
            return 0;
        },
        getTR: function () {
            return this.player.terraformRating;
        },
        getVpCount: function () {
            return this.player.victoryPointsBreakdown.total;
        },
        getEscapeVelocityPenalty: function () {
            var _a;
            return (_a = this.player.victoryPointsBreakdown.escapeVelocity) !== null && _a !== void 0 ? _a : 0;
        },
        getEscapeVelocityDetail: function () {
            var detail = '';
            if (this.player.game.gameOptions.escapeVelocityMode) {
                detail += "Escape velocity penalty: " + this.player.victoryPointsBreakdown.escapeVelocity + "\n";
                detail += "Time limit: " + this.player.game.gameOptions.escapeVelocityThreshold + " min\n";
            }
            return detail;
        },
        hideVpCount: function () {
            return !this.player.game.gameOptions.showOtherPlayersVP && !this.isActivePlayer;
        },
        showShortTags: function () {
            if (this.hideZeroTags === true)
                return true;
            return OverviewSettings_1.isTagsViewConcise(this.$root);
        },
        hasTagDiscount: function (tag) {
            var _a;
            for (var _i = 0, _b = __spreadArray(__spreadArray([], this.player.playedCards), [this.player.corporationCard]); _i < _b.length; _i++) {
                var card = _b[_i];
                if (card !== undefined) {
                    if (hasDiscount(tag, card)) {
                        return true;
                    }
                }
            }
            var turmoil = this.player.game.turmoil;
            if (tag === Tags_1.Tags.SPACE &&
                turmoil && turmoil.ruling === PartyName_1.PartyName.UNITY &&
                ((_a = turmoil.politicalAgendas) === null || _a === void 0 ? void 0 : _a.unity.policyId) === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4) {
                return true;
            }
            var iapetusColony = this.player.game.colonies.find(function (colony) { return colony.name === ColonyName_1.ColonyName.IAPETUS; });
            if (tag === 'all' &&
                iapetusColony !== undefined &&
                iapetusColony.visitor !== undefined &&
                iapetusColony.colonies.includes(this.player.color)) {
                return true;
            }
            return false;
        },
        getTagDiscountAmount: function (tag) {
            var _this = this;
            var _a, _b;
            var discount = 0;
            for (var _i = 0, _c = __spreadArray(__spreadArray([], this.player.playedCards), [this.player.corporationCard]); _i < _c.length; _i++) {
                var card = _c[_i];
                if (card !== undefined) {
                    discount += getDiscountAmount(tag, card);
                }
            }
            if (tag === Tags_1.Tags.SPACE && ((_a = this.player.game.turmoil) === null || _a === void 0 ? void 0 : _a.ruling) === PartyName_1.PartyName.UNITY) {
                if (((_b = this.player.game.turmoil.politicalAgendas) === null || _b === void 0 ? void 0 : _b.unity.policyId) === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4)
                    discount += 2;
            }
            var iapetusColony = this.player.game.colonies.find(function (colony) { return colony.name === ColonyName_1.ColonyName.IAPETUS; });
            if (tag === 'all' && iapetusColony !== undefined && iapetusColony.visitor !== undefined) {
                discount += iapetusColony.colonies.filter(function (owner) { return owner === _this.player.color; }).length;
            }
            return discount;
        },
        getTagCount: function (tagName) {
            if (tagName === SpecialTags_1.SpecialTags.COLONY_COUNT && this.showColonyCount()) {
                return this.player.coloniesCount || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.INFLUENCE && this.showInfluence()) {
                return this.player.influence || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.CITY_COUNT) {
                return this.player.citiesCount || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.NONE) {
                return this.player.noTagsCount || 0;
            }
            var basicTagFound = this.player.tags.find(function (tag) { return tag.tag === tagName; });
            if (basicTagFound !== undefined) {
                return basicTagFound.count;
            }
            return 0;
        },
        showAnimalMicrobeProtection: function (tag) {
            return (tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.MICROBE) && this.hasAnimalMicrobeProtection();
        },
        hasAnimalMicrobeProtection: function () {
            for (var _i = 0, _a = this.player.playedCards; _i < _a.length; _i++) {
                var card = _a[_i];
                if (card !== undefined && ANIMAL_MICROBE_PROTECTION.includes(card.name)) {
                    return true;
                }
            }
            return false;
        },
        showJovianMultipliers: function (tag) {
            return tag === Tags_1.Tags.JOVIAN && this.playerJovianMultipliersCount() > 0;
        },
        playerJovianMultipliersCount: function () {
            var multipliers = 0;
            for (var _i = 0, _a = this.player.playedCards; _i < _a.length; _i++) {
                var card = _a[_i];
                if (card !== undefined && JOVIAN_FULL_MULTIPLIERS.includes(card.name)) {
                    multipliers += 1;
                }
                if (card !== undefined && JOVIAN_HALF_MULTIPLIERS.includes(card.name)) {
                    multipliers += 0.5;
                }
            }
            return multipliers;
        },
    },
    template: "\n        <div class=\"player-tags\">\n            <div class=\"player-tags-main\">\n                <tag-count :tag=\"'vp'\" :count=\"getVpCount()\" :size=\"'big'\" :type=\"'main'\" :hideCount=\"hideVpCount()\" />\n                <tag-count v-if=\"showEscapeVelocity()\"\n                  class=\"tooltip tooltip-bottom\" :data-tooltip=\"getEscapeVelocityDetail()\"\n                  :tag=\"'escape'\" :count=\"getEscapeVelocityPenalty()\" :size=\"'big'\" :type=\"'main'\" />\n                <tag-count :tag=\"'tr'\" :count=\"getTR()\" :size=\"'big'\" :type=\"'main'\"/>\n                <div class=\"tag-and-discount\">\n                  <PlayerTagDiscount v-if=\"hasTagDiscount('all')\" :amount=\"getTagDiscountAmount('all')\" :color=\"player.color\" />\n                  <tag-count :tag=\"'cards'\" :count=\"getCardCount()\" :size=\"'big'\" :type=\"'main'\"/>\n                </div>\n            </div>\n            <div class=\"player-tags-secondary\">\n                <template v-if=\"showShortTags()\">\n                  <div class=\"tag-count-container\" v-for=\"tag in player.tags\">\n                    <div class=\"tag-and-discount\" :key=\"tag.tag\">\n                      <PlayerTagDiscount v-if=\"hasTagDiscount(tag.tag)\" :amount=\"getTagDiscountAmount(tag.tag)\" :color=\"player.color\" />\n                      <JovianMultiplier v-if=\"showJovianMultipliers(tag.tag)\" :amount=\"playerJovianMultipliersCount()\" />\n                      <AnimalMicrobeProtection v-if=\"showAnimalMicrobeProtection(tag.tag)\" />\n                      <tag-count :tag=\"tag.tag\" :count=\"tag.count\" :size=\"'big'\" :type=\"'secondary'\"/>\n                    </div>\n                  </div>\n                </template>\n                <template v-else>\n                    <div class=\"tag-count-container\" v-for=\"tagName in getTagsPlaceholders()\" :key=\"tagName\">\n                      <div class=\"tag-and-discount\" v-if=\"tagName !== 'separator'\">\n                        <PlayerTagDiscount v-if=\"hasTagDiscount(tagName)\" :color=\"player.color\" :amount=\"getTagDiscountAmount(tagName)\"/>\n                        <JovianMultiplier v-if=\"showJovianMultipliers(tagName)\" :amount=\"playerJovianMultipliersCount()\" />\n                        <AnimalMicrobeProtection v-if=\"showAnimalMicrobeProtection(tagName)\" />\n                        <tag-count :tag=\"tagName\" :count=\"getTagCount(tagName)\" :size=\"'big'\" :type=\"'secondary'\"/>\n                      </div>\n                      <div v-else class=\"tag-separator\"></div>\n                    </div>\n                </template>\n            </div>\n        </div>\n    ",
});
//# sourceMappingURL=PlayerTags.js.map